import { useGetPasscodeStatusQuery } from '~/store/apis/endpoints/onboardingApi/passcode/passcode.api';

export type PasscodeStatusResult =
  | { status: 'loading' }
  | { status: 'error'; refetch: () => void }
  | { status: 'ready'; hasExistingPasscode: boolean };

/**
 * Centralizes the passcode status query and its loading, error and ready
 * interpretation. The offer step's content and footer each subscribe
 * separately, for the reason given in `usePasscodeFlow`.
 */
export const usePasscodeStatus = (): PasscodeStatusResult => {
  const {
    data,
    isLoading,
    isError,
    isUninitialized,
    refetch,
  } = useGetPasscodeStatusQuery(undefined, { refetchOnMountOrArgChange: true });

  if (isUninitialized || isLoading) {
    return { status: 'loading' };
  }
  if (isError || !data) {
    return { status: 'error', refetch };
  }
  return { status: 'ready', hasExistingPasscode: data.exists };
};
